import React from 'react';
import { services } from '../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import {
  FileText,
  Globe,
  Shield,
  Scale,
  Car,
  Calculator,
  Building,
} from 'lucide-react';

const iconMap = {
  FileText,
  Globe,
  Shield,
  Scale,
  Car,
  Calculator,
  Building,
};

const ServicesSection = () => {
  return (
    <section id="servicios" className="bg-black py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-3xl md:text-4xl font-semibold text-white mb-4">
            Nuestros <span className="gold-text">Servicios</span>
          </h2>
          <p className="text-lg text-white/60 max-w-2xl mx-auto">
            Soluciones completas para la comunidad hispana
          </p>
          <div className="gold-divider w-32 mx-auto mt-8" />
        </div>

        {/* Services Grid with Accordion */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className={`service-card bg-black/50 p-6 animate-fade-in-up animate-delay-${(index + 1) * 100}`}
              >
                <Accordion type="single" collapsible className="w-full">
                  <AccordionItem value={service.id} className="border-none">
                    <AccordionTrigger className="hover:no-underline py-0 gap-4">
                      <div className="flex items-center gap-4 text-left">
                        <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center border border-[#D4AF37]/40 bg-[#D4AF37]/10">
                          {IconComponent && (
                            <IconComponent className="h-6 w-6 text-[#D4AF37]" />
                          )}
                        </div>
                        <h3 className="text-base font-medium text-white">
                          {service.title}
                        </h3>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent className="pt-4 pl-16">
                      <p className="text-white/60 text-sm leading-relaxed">
                        {service.description}
                      </p>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
